import axios from "axios";
import { applySidebarColor } from "@/assets/js/helpers/theme";

const sidebarColor = localStorage.getItem("sidebarColor");

const api = axios.create({
    baseURL: process.env.VUE_APP_URL_BACKEND,
    timeout: 30000, // 30 segundos timeout
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
    },
});

const plainAxios = axios.create({
    baseURL: process.env.VUE_APP_URL_BACKEND,
    timeout: 30000, // 30 segundos timeout
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
    },
});

// ⚠️ Lazy import para evitar errores de ciclo
let loadingStore
function getLoadingStore() {
    if (!loadingStore) {
        const { useLoadingStore } = require("@/store/loadingStore");
        loadingStore = useLoadingStore();
    }
    return loadingStore;
}

function clearSessionAndRedirect() {
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("refresh_token");
    sessionStorage.removeItem("expires_token");
    window.location.href = process.env.VUE_APP_URL_FRONTEND + "/signin";
    // const fullUrl = process.env.VUE_APP_URL_FRONTEND + "/signin";

}

api.interceptors.request.use(
    async (config) => {
        getLoadingStore().setLoading(true);

        const token = sessionStorage.getItem("token");
        const expiresToken = sessionStorage.getItem("expires_token");
        const refreshToken = sessionStorage.getItem("refresh_token");
        const diference = parseInt(expiresToken) - Date.now();

        // Solo renovar si faltan menos de 5 minutos (en lugar de 10)
        if (diference < 5 * 60 * 1000 && diference > 0 && token && refreshToken) {
            try {
                const response = await plainAxios.post("/refresh", null, {
                    headers: {
                        Authorization: `Bearer ${refreshToken}`,
                    },
                });

                const newToken = response.data.access_token;
                const newExpiresToken = Date.now() + response.data.expires_in * 1000 - 5000;

                sessionStorage.setItem("token", newToken);
                sessionStorage.setItem("expires_token", newExpiresToken);

                config.headers.Authorization = `Bearer ${newToken}`;
                api.defaults.headers.common["Authorization"] = `Bearer ${newToken}`;

            } catch (err) {
                console.error("Error al refrescar token", err);
                clearSessionAndRedirect();
            }
        } else if (token && parseInt(expiresToken) > Date.now()) {
            config.headers.Authorization = `Bearer ${token}`;
        } else if (expiresToken && parseInt(expiresToken) < Date.now()) {
            clearSessionAndRedirect();
        }

        return config;
    },
    (error) => {
        getLoadingStore().setLoading(false);
        return Promise.reject(error);
    }
);

api.interceptors.response.use(
    (response) => {
        if (sidebarColor) applySidebarColor(sidebarColor);
        getLoadingStore().setLoading(false);
        return response;
    },
    (error) => {
        console.log(error);

        getLoadingStore().setLoading(false);
        if (sidebarColor) applySidebarColor(sidebarColor);

        if (error.response) {
            if (!error.response.data.user_message) {
                switch (error.response.status) {
                    case 401:
                        window.llamarToast && window.llamarToast("No estás autenticado", "error");
                        break;
                    case 403:
                        window.llamarToast && window.llamarToast("No tienes permisos suficientes para realizar esta acción", "error");
                        break;
                    case 404:
                        window.llamarToast && window.llamarToast("Recurso no encontrado", "error");
                        break;
                    case 422:
                        window.llamarToast && window.llamarToast(error.response.data.message, "error");
                        break;
                    case 500:
                        window.llamarToast && window.llamarToast("Error del servidor intenta nuevamente o contacta al administrador", "error");
                        break;
                    default:
                        window.llamarToast && window.llamarToast(error.response.data.message || "Error desconocido", "error");
                        break;
                }
            } else {
                window.llamarToast && window.llamarToast(error.response.data.message, "error");
            }
        } else {
            // Error de red o sin respuesta del servidor
            window.llamarToast && window.llamarToast("Error de red o servidor", "error");
        }

        return Promise.reject(error);
    }
);
export default api;
